import { ChangeDetectionStrategy, Component } from "@angular/core";
import { SkeletonModule } from "primeng/skeleton";

import { DataListItemTemplateDirective, DataListSkeleton } from "@intocare/design/design-system-base";

@Component({
	selector: "ic-restrictive-measure-list-skeleton",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DataListSkeleton, DataListItemTemplateDirective, SkeletonModule],
	templateUrl: "./restrictive-measure-list.skeleton.html",
})
export class RestrictiveMeasureListSkeleton {}
